import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheck, FaLayerGroup } from "react-icons/fa";

import CustomNavbar from "../components/CustomNavbar";
import Footer from "../components/Footer";
import { services } from "../data/services";
import { industries } from "../data/industries";

const PROMISES = [
  "Project & Programme Management",
  "Enterprise Technology Solutions",
  "Test Management & QA",
  "Digital Transformation",
  "Website Development",
  "Digital Marketing",
];

function Services() {
  return (
    <>
      <CustomNavbar />

      <style>{`
        .srv {
          --peach-deep: #ff6b35;
          --peach: #ff9066;
          --peach-soft: #f3c09f;
          --peach-tint: #ffe9e0;
          --peach-ink: #c2410c;
        }

        /* --- Hero --- */
        .srv-hero {
          position: relative; overflow: hidden;
          padding: clamp(52px, 7vw, 88px) 0;
          background:
            radial-gradient(42rem 24rem at 86% 6%, rgba(255,107,53,.30), transparent 62%),
            linear-gradient(135deg, #ff9066 0%, #f3c09f 48%, #fff8f5 100%);
          color: #0f172a;
        }
        .srv-hero__blob {
          position: absolute; border-radius: 50%; pointer-events: none;
          filter: blur(80px); opacity: .5;
          width: 24rem; height: 24rem; bottom: -9rem; left: -8rem;
          background: radial-gradient(circle, #fff3ec, transparent 70%);
        }
        .srv-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: #ffffffdd; color: var(--peach-ink);
          padding: 9px 22px; border-radius: 999px;
          font-weight: 700; font-size: .78rem; letter-spacing: .1em;
          box-shadow: 0 8px 20px rgba(194,65,12,.16);
        }
        .srv-hero__title {
          margin-top: 22px; font-weight: 800; letter-spacing: -.02em;
          font-size: clamp(1.9rem, 4.6vw, 3.1rem); line-height: 1.14;
        }
        .srv-hero__title em {
          font-style: normal;
          background: linear-gradient(96deg, #c2410c, #ff6b35 60%, #b91c1c);
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .srv-hero__lead {
          margin-top: 18px; color: #4a3a33;
          font-size: clamp(1rem, 1.7vw, 1.08rem); line-height: 1.85; max-width: 560px;
        }
        .srv-btn {
          display: inline-flex; align-items: center; gap: 10px;
          text-decoration: none; font-weight: 700;
          padding: 13px 26px; border-radius: 14px;
          transition: transform .22s ease, box-shadow .22s ease, background .22s ease;
        }
        .srv-btn--solid {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          color: #0f172a; box-shadow: 0 12px 28px rgba(255,107,53,.4);
        }
        .srv-btn--solid:hover, .srv-btn--solid:focus-visible {
          color: #fff; transform: translateY(-3px);
          box-shadow: 0 18px 38px rgba(255,107,53,.55);
        }
        .srv-btn--ghost {
          background: rgba(255,255,255,.72); color: #0f172a;
          border: 1.5px solid rgba(15,23,42,.16);
        }
        .srv-btn--ghost:hover, .srv-btn--ghost:focus-visible {
          background: #fff; color: #0f172a; transform: translateY(-3px);
        }
        .srv-btn svg { transition: transform .22s ease; }
        .srv-btn:hover svg { transform: translateX(4px); }

        /* Promise card */
        .srv-promise {
          background: #fff; border-radius: 24px;
          padding: clamp(26px, 3.4vw, 38px);
          box-shadow: 0 26px 55px rgba(194,65,12,.22);
          border: 1px solid #ffe3d6;
        }
        .srv-promise__h {
          font-weight: 800; color: #0f172a; font-size: 1.3rem; margin-bottom: 20px;
        }
        .srv-promise__row {
          display: flex; align-items: flex-start; gap: 11px;
          color: #334155; font-size: .95rem; margin-bottom: 12px;
        }
        .srv-tick {
          flex-shrink: 0; margin-top: 2px;
          width: 21px; height: 21px; border-radius: 50%;
          display: grid; place-items: center; font-size: .58rem; color: #fff;
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
        }
        .srv-promise__note {
          margin: 18px 0 0; padding-top: 16px;
          border-top: 1px solid #f1e4dc;
          color: #64748b; font-size: .9rem; line-height: 1.8;
        }

        /* --- Grid --- */
        /* Ends white so the dark CTA band below reads as a clean break. */
        .srv-list {
          padding: clamp(56px, 7vw, 92px) 0;
          background: linear-gradient(180deg, #fff8f5 0%, #ffffff 62%, #ffffff 100%);
        }
        .srv-h2 {
          margin-top: 20px; color: #0f172a; font-weight: 800;
          font-size: clamp(1.7rem, 3.6vw, 2.7rem);
          line-height: 1.16; letter-spacing: -.02em;
        }
        .srv-lead {
          max-width: 720px; margin: 14px auto 0;
          color: #64748b; line-height: 1.85; font-size: clamp(.96rem, 1.6vw, 1.05rem);
        }

        .srv-card {
          position: relative; overflow: hidden;
          display: flex; flex-direction: column; height: 100%;
          padding: 30px 26px 26px;
          border-radius: 22px; background: #fff;
          border: 1px solid #f0e4dd; text-decoration: none;
          box-shadow: 0 6px 22px rgba(194,65,12,.07);
          transition: transform .26s ease, box-shadow .26s ease, border-color .26s ease;
        }
        .srv-card::before {
          content: ""; position: absolute; top: 0; left: 0; right: 0; height: 4px;
          background: linear-gradient(90deg, var(--peach-deep), var(--peach-soft));
          transform: scaleX(0); transform-origin: left;
          transition: transform .34s cubic-bezier(.22,1,.36,1);
        }
        .srv-card:focus-visible { outline: 3px solid var(--peach-deep); outline-offset: 3px; }
        .srv-card__num {
          position: absolute; top: 16px; right: 22px;
          font-size: 2.5rem; font-weight: 800; line-height: 1;
          color: var(--peach); opacity: .16; transition: opacity .26s ease;
        }
        .srv-card__icon {
          width: 64px; height: 64px; border-radius: 18px; margin-bottom: 20px;
          display: grid; place-items: center;
          background: var(--peach-tint); color: var(--peach-deep);
          transition: background .26s ease, color .26s ease, transform .26s ease;
        }
        .srv-card__title { color: #0f172a; font-weight: 700; font-size: 1.2rem; margin-bottom: 10px; }
        .srv-card__text { color: #64748b; line-height: 1.75; font-size: .94rem; margin-bottom: 16px; }
        .srv-card__chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 18px; }
        .srv-card__chip {
          display: inline-flex; align-items: center; gap: 6px;
          background: var(--peach-tint); color: var(--peach-ink);
          border-radius: 999px; padding: 4px 11px; font-size: .72rem; font-weight: 600;
        }
        .srv-card__chip svg { font-size: .56rem; flex-shrink: 0; }
        .srv-card__more {
          margin-top: auto; display: inline-flex; align-items: center; gap: 8px;
          color: var(--peach-ink); font-weight: 700; font-size: .92rem;
        }
        .srv-card__more svg { transition: transform .26s ease; }

        /* A mouse hovers; a finger can't. On touch, lib/touchMotion.js adds
           .is-live as the card scrolls through the middle of the screen. */
        .srv-card:hover,
        .srv-card.is-live {
          transform: translateY(-8px);
          box-shadow: 0 22px 46px rgba(194,65,12,.18);
          border-color: var(--peach-soft);
        }
        .srv-card:hover::before,
        .srv-card.is-live::before { transform: scaleX(1); }
        .srv-card:hover .srv-card__num,
        .srv-card.is-live .srv-card__num { opacity: .3; }
        .srv-card:hover .srv-card__icon,
        .srv-card.is-live .srv-card__icon {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          color: #fff; transform: scale(1.06);
        }
        .srv-card:hover .srv-card__more svg,
        .srv-card.is-live .srv-card__more svg { transform: translateX(5px); }

        /* --- Closing CTA --- */
        /* Navy, not peach: the footer's peach CTA panel overlaps up into
           this section and peach-on-peach would muddy both. */
        .srv-cta {
          position: relative; overflow: hidden;
          padding: clamp(56px, 7vw, 88px) 0 clamp(86px, 9vw, 128px);
          color: #fff;
          background:
            radial-gradient(40rem 22rem at 84% 10%, rgba(255,107,53,.28), transparent 62%),
            linear-gradient(140deg, #131f36 0%, #0f172a 50%, #0b1120 100%);
        }
        .srv-cta__mesh {
          position: absolute; inset: 0; pointer-events: none;
          background-image:
            linear-gradient(rgba(255,144,102,.07) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,144,102,.07) 1px, transparent 1px);
          background-size: 66px 66px;
          mask-image: radial-gradient(72% 60% at 50% 45%, #000 20%, transparent 100%);
          -webkit-mask-image: radial-gradient(72% 60% at 50% 45%, #000 20%, transparent 100%);
        }
        .srv-cta__title {
          font-weight: 800; letter-spacing: -.02em; color: #fff;
          font-size: clamp(1.7rem, 3.8vw, 2.8rem); line-height: 1.16;
        }
        .srv-cta__title em {
          font-style: normal;
          background: linear-gradient(105deg, var(--peach-soft), var(--peach) 55%, var(--peach-deep));
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .srv-cta__text {
          max-width: 700px; margin: 16px auto 0;
          color: #cbd5e1; line-height: 1.85;
        }
        .srv-sectors {
          display: flex; flex-wrap: wrap; gap: 12px;
          justify-content: center; margin-top: 32px;
        }
        .srv-sector {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 12px 20px; border-radius: 999px; text-decoration: none;
          background: rgba(255,255,255,.05);
          border: 1px solid rgba(255,144,102,.28);
          color: #e2e8f0; font-weight: 600; font-size: .92rem;
          transition: background .24s ease, color .24s ease,
                      border-color .24s ease, transform .24s ease;
        }
        .srv-sector svg { color: var(--peach); transition: color .24s ease; }
        .srv-sector:hover, .srv-sector:focus-visible {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          border-color: transparent; color: #0f172a; transform: translateY(-3px);
        }
        .srv-sector:hover svg { color: #fff; }
        @media (max-width: 575.98px) { .srv-btn { width: 100%; justify-content: center; } }

        @media (prefers-reduced-motion: reduce) {
          .srv-card, .srv-card::before, .srv-card__icon,
          .srv-btn, .srv-sector { transition: none; }
          .srv-card:hover, .srv-btn:hover, .srv-sector:hover { transform: none; }
        }
      `}</style>

      <div className="srv">
        {/* Hero */}
        <section className="srv-hero">
          <span className="srv-hero__blob" />
          <Container style={{ position: "relative", zIndex: 1 }}>
            <Row className="align-items-center g-5">
              <Col lg={6} data-aos="fade-right">
                <span className="srv-badge">
                  <FaLayerGroup />
                  OUR SERVICES
                </span>

                {/* theme.css hides <br> in section headings below 576px, so
                    the explicit space stops the halves concatenating. */}
                <h1 className="srv-hero__title">
                  Delivering Excellence
                  <br />{" "}
                  <em>Through Innovation</em>
                </h1>

                <p className="srv-hero__lead">
                  We provide consulting, technology, and transformation services
                  that help organizations improve performance, accelerate growth,
                  and achieve strategic business objectives.
                </p>

                {/* Both buttons were inert before — no link, no handler */}
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <Link to="/contact" className="srv-btn srv-btn--solid">
                    Schedule Consultation
                    <FaArrowRight />
                  </Link>
                  <Link to="/case-studies" className="srv-btn srv-btn--ghost">
                    View Case Studies
                  </Link>
                </div>
              </Col>

              <Col lg={6} data-aos="fade-left">
                <div className="srv-promise">
                  <h2 className="srv-promise__h">Why Clients Choose Us</h2>

                  {PROMISES.map((p) => (
                    <div className="srv-promise__row" key={p}>
                      <span className="srv-tick">
                        <FaCheck />
                      </span>
                      {p}
                    </div>
                  ))}

                  <p className="srv-promise__note">
                    Delivering technology, transformation, and digital excellence
                    across multiple industries and business sectors.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Core services */}
        <section className="srv-list">
          <Container>
            <div className="text-center mb-5" data-aos="fade-up">
              <span className="srv-badge">WHAT WE OFFER</span>
              <h2 className="srv-h2">Our Core Services</h2>
              <p className="srv-lead">
                Delivering strategic solutions that help organizations achieve
                sustainable success, operational excellence, and digital growth.
              </p>
            </div>

            <Row className="g-4">
              {services.map((service, i) => {
                const { Icon } = service;
                return (
                  <Col
                    xl={4}
                    md={6}
                    key={service.slug}
                    data-aos="fade-up"
                    data-aos-delay={(i % 3) * 90}
                  >
                    <Link to={`/services/${service.slug}`} className="srv-card" data-live>
                      <span className="srv-card__num">
                        {String(i + 1).padStart(2, "0")}
                      </span>

                      <span className="srv-card__icon">
                        <Icon size={30} />
                      </span>

                      <h3 className="srv-card__title">{service.title}</h3>
                      <p className="srv-card__text">{service.description}</p>

                      {/* Detail-page content the listing never surfaced */}
                      <span className="srv-card__chips">
                        {(service.offerings || []).slice(0, 3).map((o) => (
                          <span className="srv-card__chip" key={o}>
                            <FaCheck />
                            {o}
                          </span>
                        ))}
                      </span>

                      <span className="srv-card__more">
                        Learn more <FaArrowRight />
                      </span>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </section>

        {/* Sectors — deliberately NOT a second call to action. The footer
            now carries a CTA panel on every page, and a "Ready to transform
            your business?" band directly above "Ready to start your next
            programme?" read as a duplicate. */}
        <section className="srv-cta">
          <span className="srv-cta__mesh" />
          <Container className="text-center" style={{ position: "relative", zIndex: 1 }}>
            <h2 className="srv-cta__title" data-aos="fade-up">
              Delivered Across <em>Regulated, High-Stakes Sectors</em>
            </h2>

            <p className="srv-cta__text" data-aos="fade-up" data-aos-delay="80">
              Every service above is shaped by the industry it lands in — the
              regulations, the constraints, and the customers involved.
            </p>

            <div
              className="srv-sectors"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              {industries.map(({ slug, title, Icon }) => (
                <Link to={`/industries/${slug}`} className="srv-sector" key={slug}>
                  <Icon />
                  {title}
                </Link>
              ))}
            </div>
          </Container>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Services;
